import { useEffect } from "react";
import { useRecoilState, useResetRecoilState } from "recoil";
import { myTimesheetEntityEditorDataState } from "my-timesheet/states";

export const useMyTimesheetEntityEditorDataState = (initialData?: any) => {
  const [state, setState] = useRecoilState(myTimesheetEntityEditorDataState);
  const resetState = useResetRecoilState(myTimesheetEntityEditorDataState);

  const handleSetState = (value: any) => {
    setState(value);
  };

  useEffect(() => {
    if (initialData) {
      setState(initialData);
    }
  }, [initialData]); // eslint-disable-line react-hooks/exhaustive-deps

  return { state, setState: handleSetState, resetState };
};

export default useMyTimesheetEntityEditorDataState;
